/* Copyright (c) 2018 Scaper */

import { UserInfo } from "@firebase/auth-types";
import * as React from "react";
import { connect } from "react-redux";
import { Redirect } from "react-router";
import { IApi } from "../../api/api";
import { APP_PATH, ISignInRouteParams } from "../../paths/pathIndex";
import { IAppState } from "../appState";
import { SignIn } from "./signIn";

interface IOwnProps {
    api: IApi;
    routeParams: ISignInRouteParams;
}

interface IStateProps {
    userInfo: UserInfo | false | undefined;
}

type IProps = IOwnProps & IStateProps;

class UnconnectedSignInPage extends React.PureComponent<IProps, {}> {
    public render() {
        const { api, routeParams, userInfo } = this.props;

        if (userInfo == null) {
            return "// TODO: LOADING";
        }

        if (userInfo === false) {
            return (
                <>
                    <h2>Sign In</h2>

                    <div className="divider"></div>

                    <div className="section">
                        <SignIn api={api} />
                    </div>
                </>
            );
        }

        const { from } = routeParams;
        const to = from != null ? from : APP_PATH;
        return <Redirect to={to} />;
    }
}

function mapStateToProps(state: IAppState): IStateProps {
    const { user } = state;
    const { userInfo } = user;
    return { userInfo };
}

export const SignInPage = connect<IStateProps, {}, IOwnProps, IAppState>(mapStateToProps)(UnconnectedSignInPage);
